import React from 'react';
import { IconButton, Tooltip } from '@mui/material';

const getOrderNotes = (job) => String(job?.orderNotes || '').trim();

/**
 * Compact flag for printlist when the parent order has notes.
 * Hidden when there are no order notes.
 */
const OrderNotesIndicatorButton = ({ job, onClick, size = 'default' }) => {
  const notes = getOrderNotes(job);
  if (!notes) return null;

  const dimension = size === 'compact' ? 30 : 36;
  const fontSize = size === 'compact' ? '0.85rem' : '1rem';
  const title = notes.length > 120 ? `${notes.slice(0, 120)}…` : notes;

  return (
    <Tooltip title={title}>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onClick?.(job);
        }}
        aria-label="Order notes"
        sx={{
          width: dimension,
          height: dimension,
          flexShrink: 0,
          backgroundColor: 'rgba(var(--al-primary-rgb), 0.15)',
          color: 'var(--al-primary)',
          border: '1px solid rgba(var(--al-primary-rgb), 0.4)',
          borderRadius: 0,
          fontSize,
          p: 0,
          '&:hover': {
            backgroundColor: 'rgba(var(--al-primary-rgb), 0.25)',
            borderColor: 'var(--al-primary)'
          }
        }}
      >
        📝
      </IconButton>
    </Tooltip>
  );
};

export { getOrderNotes };
export default OrderNotesIndicatorButton;
